import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77c1b801"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel-section-header gutter-s5" }
const _hoisted_2 = { class: "ml-s3" }
const _hoisted_3 = { class: "h1" }
const _hoisted_4 = { class: "text-gradient-light" }
const _hoisted_5 = { class: "title mt-s1" }
const _hoisted_6 = { key: 0 }

import { useUtils } from '@/composables/utils/useUtils';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ExternalLink from '@/components/ExternalLink.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionHeader',
  props: {
    section: null,
    subSection: null,
    howLink: null
  },
  setup(__props: any) {

const props = __props as {
  section: string;
  subSection?: string;
  howLink?: string;
}



const { t } = useI18n();

const { openExternalLink } = useUtils();
const textKey = computed(
  () => `aprBanner.${props.section}.${props.subSection ? props.subSection + '.' : ''}`,
);
const title = computed(() => t(`${textKey.value}title`));
const subtitle = computed(() => t(`${textKey.value}subtitle`));

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(title)), 1)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(subtitle)), 1)
    ]),
    (__props.howLink)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_Button, {
            class: "button-base button-float",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openExternalLink)(__props.howLink))),
            label: _unref(t)('howItWorks'),
            icon: "pi pi-chevron-right",
            "icon-pos": "right"
          }, {
            default: _withCtx(() => [
              _createVNode(ExternalLink, {
                label: _unref(t)('howItWorks'),
                url: __props.howLink,
                class: "text-sm",
                color: "front"
              }, null, 8, ["label", "url"])
            ]),
            _: 1
          }, 8, ["label"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})